import React, { useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { useReviewsData } from "hooks/useReviewsParams";
import { addABData, addAddressData, addRefererData } from "Utils";
import { AddReviewV2 } from "ComponentsUI/Reviews";
import { sendMetriks } from "Services/sendMetriks";

const AddReviewContainerV2 = (props) => {
	const {
		ApplicationModel: {
			text,
			siteCode,
			currentRegion,
			windowSizeModel: { windowSizes },
			sendingStore,
		},
		ApplicationModel,
		queryType,
		reviewLocation,
		selectProvidersPlaceholder,
		textHeader,
	} = props;
	const { providersList } = useReviewsData(queryType, reviewLocation);
	const [viewReview, setViewReview] = useState(false);
	const [needHelper, setNeedHelper] = useState(false);
	const [reviewText, setReviewText] = useState("");
	const [userName, setUserName] = useState("");
	const [reviewProvider, setReviewProvider] = useState(null);
	const [errors, setErrors] = useState({
		reviewTextError: "",
		reviewProviderError: "",
		error: false,
	});

	if (!providersList.length) {
		return null;
	}

	const checkValueErrors = () => {
		if (!reviewProvider || !reviewText.trim().length) {
			setErrors((errors) => ({
				...errors,
				reviewTextError: !reviewText.trim().length ? text.writing_review : "",
				reviewProviderError: !reviewProvider ? text.select_provider : "",
				error: true,
			}));

			return false;
		}

		if (errors.error) {
			setErrors((errors) => ({
				...errors,
				reviewTextError: "",
				reviewProviderError: "",
				error: false,
			}));
		}

		return true;
	};

	const sendReview = (callback) => {
		if (!checkValueErrors()) {
			return;
		}

		if (reviewLocation === "street") {
			sendingStore.sendMetriksAndSaveArray("CLICK_OTPR_OTZYV_STREET");
		} else if (reviewLocation === "house") {
			sendingStore.sendMetriksAndSaveArray("CLICK_OTPR_OTZYV_HOUSE");
		}

		let data = {
			site_code: siteCode,

			username: userName,
			place_review: reviewLocation,

			short: "1",
			order_id: "0",
			review: reviewText.trim(),
			review_required: "1",

			provider_id: reviewProvider.id,
			provider: reviewProvider.name,
			provider_isset: "0",

			region_id: currentRegion?.id || "0",
			address_required: "0",

			not_rating: "1",

			tags_synonym: "",
			tags_add_positive_input: "",
			tags_add_negative_input: "",
			not_want_leave_data: 0,
			notice_comment: "1",
			personal_data: "1",
			agree_with_rules: "1",
		};

		data = addAddressData(data, ApplicationModel);
		data = addABData(data);
		data = addRefererData(data, ApplicationModel);

		return sendingStore.onSendShortReview(data).then((data) => {
			if (!data.errors) {
				setNeedHelper(() => false);
				setReviewText(() => "");
				setUserName(() => "");
				setReviewProvider(() => null);
				return props.openPopup();
			} else {
				setErrors((error) => ({
					...errors,
					reviewProviderError: text.SOME_PROBLEM,
					error: true,
				}));
			}
		});
	};

	const changeNeedHelperHandler = (value) => {
		setNeedHelper(() => value);
		sendingStore.sendMetriksAndSaveArray("CLICK_ON_GPT");
	};

	const changeReviewTextHandler = (e) => {
		setReviewText(() => e.target.value);
	};

	const changeUserNameHandler = (e) => {
		if (e.target.value.length <= 27) {
			setUserName(() => e.target.value);
		}
	};

	const changeReviewProviderHandler = (value) => {
		if (value.length) {
			setReviewProvider(() => value[0]);
		} else {
			setReviewProvider(() => null);
		}
	};

	const wasViewed = (view) => {
		if (view && reviewLocation === "house") {
			setViewReview(() => true);
			sendMetriks("OPEN_OTZYV_DOM");
		}
	};

	return (
		<VisibilitySensor onChange={(visible) => wasViewed(visible)}>
			<AddReviewV2
				text={text}
				textHeader={textHeader}
				windowSizes={windowSizes}
				providersList={providersList}
				needHelper={needHelper}
				reviewText={reviewText}
				userName={userName}
				reviewProvider={reviewProvider}
				errors={errors}
				sendReview={() => sendReview()}
				changeNeedHelperHandler={(value) => changeNeedHelperHandler(value)}
				changeReviewTextHandler={(value) => changeReviewTextHandler(value)}
				changeUserNameHandler={(value) => changeUserNameHandler(value)}
				changeReviewProviderHandler={(value) => changeReviewProviderHandler(value)}
				selectProvidersPlaceholder={selectProvidersPlaceholder}
			/>
		</VisibilitySensor>
	);
};

AddReviewContainerV2.propTypes = {
	queryType: PropTypes.string.isRequired,
	reviewLocation: PropTypes.string.isRequired,
	textHeader: PropTypes.string.isRequired,
	selectProvidersPlaceholder: PropTypes.string.isRequired,
};

export default inject("ApplicationModel")(observer(AddReviewContainerV2));
